<template>
  <div class="tjAbout">
    <div class="content">
      <div class="lContent">
        <div class="rightBor">
          <div class="bor">
            <p></p>
            <p>推介活动</p>
          </div>
        </div>
        <div class="back">
          <div>简介</div>
        </div>
      </div>
      <div class="rContent">
        <div class="rContent_jj" v-html="introduction">
        </div>
      </div>
      <div class="borderBott"></div>
    </div>
    <div class="enterprise">
      <div class="name">推荐企业</div>
      <vue-seamless-scroll :data="companyList" :class-option="mtOptionLeft" class="seamless-warp">
        <el-row type="flex" :gutter="18.3" class="item">
          <el-col :span="4.8" v-for="(item,index) in companyList" :key="index" :class="[ companyList.length < 21 ? 'a' + index : '']">
            <div class="product_event" @click="jumpImgLink(item)">
              <img :src="$getSrc(item.image)" alt />
            </div>
          </el-col>
        </el-row>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageIndex: 1,
      pageSize2: 20,
      totalPage: 3,
      listData: [], // 轮播
      introduction: "", // 简介
      companyList: [], // 推荐企业
    };
  },
  computed: {
    mtOptionLeft() {
      return {
        limitMoveNum: 21,
        direction: 1,
        step: 0.2,
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$http({
        url: "promotion/getTjIndex",
        method: "get",
      }).then(({ data }) => {
        let { code, lunBoList, companyList, introduce } = data;
        if (code === 0) {
          this.listData = lunBoList;
          this.introduction = introduce.content;
          this.companyList = companyList;
        }
      });
    },

    jumpImgLink(item) {
      if (item.content) {
        window.open(item.content);
      }
    },

    eventIndex(event) {
    },
  },
};
</script>
<style lang="scss">
.tjAbout {
  .el-carousel__indicators--vertical {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.tjAbout {
  height: 1040px;
  .content {
    width: 100%;
    height: 365px;
    margin-bottom: 73px;
    .lContent {
      width: 259px;
      height: 296px;
      padding-top: 1px;
      position: relative;
      float: left;
      .rightBor {
        width: 259px;
        height: 296px;
        border-right: 1px solid #e6e6e6;
        .bor {
          width: 143px;
          height: 178px;
          border: 1px solid #a3a3a3;
          text-align: center;
          color: #a3a3a3;
          font-size: 14px;
          margin: 70px 0 0 24px;
          p:first-child {
            width: 60px;
            height: 1px;
            background-color: #a3a3a3;
            margin: 109px auto 0;
          }
          p:last-child {
            margin-top: 10px;
          }
        }
      }
      .back {
        width: 164px;
        height: 80px;
        background-color: #ffffff;
        position: absolute;
        top: 94px;
        right: 31px;
        div {
          height: 59px;
          background-color: #7eb341;
          text-align: center;
          line-height: 59px;
          color: #ffffff;
          font-size: 28px;
          margin: 11px auto;
        }
      }
    }
    .rContent {
      width: 907px;
      height: 295px;
      float: right;
      margin-top: 70px;
      .rContent_jj {
        height: 265px;
        margin: 0 0 30px 33px;
        line-height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 9;
        -webkit-box-orient: vertical;
      }
    }
    .borderBott {
      width: 1164px;
      height: 0.5px;
      background-color: #e6e6e6;
      float: right;
    }
  }
  .enterprise {
    .name {
      text-align: left;
      font-size: 28px;
      color: #7eb341;
      border-bottom: 1px solid #a3a3a3;
      padding-bottom: 19px;
      margin-bottom: 31px;
    }
  }
  .seamless-warp {
    height: 454px;
    overflow: hidden;
  }

  .product_event {
    width: 223px;
    height: 98px;
    border: 1px solid #f3f3f3;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .el-row {
    flex-wrap: wrap;
  }
  .el-col {
    margin-top: 18px;
  }
  .a0,
  .a1,
  .a2,
  .a3,
  .a4 {
    margin-top: 0;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #d3a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
}
</style>